/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ExactInputs */

const cs_enum_exact = /** @type {(inputs: Enum_ExactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesná adresa`)
};

const en_enum_exact = /** @type {(inputs: Enum_ExactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exact`)
};

/**
* | output |
* | --- |
* | "Exact" |
*
* @param {Enum_ExactInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_exact = /** @type {((inputs?: Enum_ExactInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ExactInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_exact(inputs)
	return cs_enum_exact(inputs)
});